import { useActions } from '@root/core/hooks/useActions';
import { useTypedSelector } from '@root/core/hooks/useTypedSelector';
import { returnDetail } from '@root/state/reducers/return_disposal/returnDisposalReducer';
import { formatDateTime } from '@root/utils/helpers/formatDate';
import { Button, DatePicker, Form, Input, Select, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { ReactElement, forwardRef, useEffect, useImperativeHandle, useMemo, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import returnDisposalService from '@modules/Warehouse/Return/Service/returnDisposal';
import Popup from '@core/components/Popup';
interface DataType {
  key: React.Key;
  updateDate?: string | ReactElement;
  courier?: string | ReactElement;
  trackingNumber?: number | ReactElement;
  status?: string | ReactElement;
  deliveryStatus: string | ReactElement;
}
interface ParamType {
  id: string;
}

const ProgressForm = forwardRef(({ detailData, showInspectionStatus = false ,isChange = false}: { detailData: returnDetail, showInspectionStatus?: boolean , isChange?: boolean},ref) =>{
  const { Option } = Select;
  const [form] = Form.useForm();
  const [status, setStatus] = useState(true);
  const { handleSaveReturn } = useActions();
  const { id } = useParams<ParamType>();
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState('');
  const inputRef: any = useRef();

  useImperativeHandle(ref, () => {
    return inputRef.current;
  });
  const { handleReturnDisposalDetail } = useActions();

  const canUpdate = detailData?.status === 'Complete' ? true : false;

  const saveHandle = async (values: any) => {
    const response = await returnDisposalService.putReturnSave(id,
      showInspectionStatus ? values.status : detailData.status,
      formatDateTime(values?.updateDateSubmit),
      values.courier,
      values.trackingNumber,
      values.deliveryStatus);

    if (response.id) {
      setPopupContent('Saved');
    } else {
      setPopupContent('Failed to save');
    }
    setPopupOpen(true);
    handleReturnDisposalDetail(id);
  };
  const columns: ColumnsType<DataType> = [
    // {
    //   title: 'Update Date',
    //   dataIndex: 'updateDate',
    //   width: '20%'
    // },
    // {
    //   title: 'Courier',
    //   dataIndex: 'courier'
    // },
    // {
    //   title: 'Tracking Number',
    //   dataIndex: 'trackingNumber'
    // },
    {
      title: 'Delivery status',
      dataIndex: 'deliveryStatus'
    },
    {
      title: 'Inspection status',
      dataIndex: 'status'
    }
  ];

  const columnsNoInspection: ColumnsType<DataType> = [
    {
      title: 'Update Date',
      dataIndex: 'updateDate',
      width: '20%'
    },
    {
      title: 'Courier',
      dataIndex: 'courier'
    },
    {
      title: 'Tracking Number',
      dataIndex: 'trackingNumber'
    },
    {
      title: 'Delivery status',
      dataIndex: 'deliveryStatus'
    }
  ];

  const defaultValue = useMemo(() => {
    return {
      trackingNumber: detailData ? detailData?.trackingNumber : '',
      status: detailData ? detailData?.status : '',
      updateDate: detailData?.warehouseUpdateDate
        ? moment(detailData?.warehouseUpdateDate).utc()
        : null,
      courier: detailData ? detailData?.courier : '',
      deliveryStatus: detailData ? detailData?.deliveryStatus : ''
    };
  }, [detailData]);

  const onChangeStatus = (value: string) => {
    if (detailData?.status === 'Request') {
      if (value === 'Inprogress' || value === 'Complete') {
        setStatus(false);
      }
    }
    if (detailData?.status === 'Inprogress') {
      if (value === 'Complete') {
        setStatus(false);
      } else {
        setStatus(true);
      }
    }
  };

  useEffect(() => {
    form.setFieldsValue(defaultValue);
    if (detailData?.status === 'Inprogress') {
      setStatus(true);
    }
  }, [form, defaultValue]);

  const warehouseUpdateDate = detailData?.warehouseUpdateDate
    ? moment(detailData?.warehouseUpdateDate)
    : '';

  const dataSource = (): DataType[] => {
    return [
      {
        key: '1',
        // updateDate: (
        //   <Form.Item>
        //     {detailData?.status === 'Request' && (
        //       <Form.Item name={['updateDateSubmit']}>
        //         <DatePicker
        //           style={{ width: '100%' }}
        //           placeholder="YYYY.MM.DD 00:00:00"
        //           className="inputRadious"
        //           disabled={canUpdate}
        //         />
        //       </Form.Item>
        //     )}
        //     {detailData?.status === 'Inprogress' && (
        //       <Form.Item name={'updateDateSubmit'}>
        //         <DatePicker
        //           className="inputRadious"
        //           disabled={canUpdate}
        //           style={{ width: '100%' }}
        //           placeholder="YYYY.MM.DD 00:00:00"
        //         />
        //       </Form.Item>
        //     )}
        //     {detailData?.status === 'Complete' && (
        //       <Form.Item name={'updateDate'}>
        //         <DatePicker
        //           style={{ width: '100%' }}
        //           className="inputRadious"
        //           disabled={canUpdate}
        //           format={'YYYY.MM.DD hh:mm:ss A'}
        //           placeholder="YYYY.MM.DD 00:00:00"
        //         />
        //       </Form.Item>
        //     )}
        //   </Form.Item>
        // ),
        // courier: (
        //   <Form.Item
        //     name={['courier']}
        //     rules={[
        //       {
        //         pattern: new RegExp(/^[a-zA-Z\s]*$/),
        //         message: 'Only English can be entered'
        //       }
        //     ]}
        //   >
        //     <Input className="inputRadious" disabled={canUpdate} />
        //   </Form.Item>
        // ),
        // trackingNumber: (
        //   <Form.Item
        //     name={['trackingNumber']}
        //     rules={[
        //       {
        //         pattern: new RegExp(/^[a-zA-Z0-9\s]*$/),
        //         message: 'Only English can be entered'
        //       }
        //     ]}
        //   >
        //     <Input className="inputRadious" disabled={canUpdate} />
        //   </Form.Item>
        // ),
        deliveryStatus: (
          <Form.Item
            name={['deliveryStatus']}
            rules={[
              {
                required: true,
                message: 'Input status!'
              }
            ]}
          >
            <Select
              className="quantitySelect"
              disabled={canUpdate}
              onChange={onChangeStatus}
            >
              <Option value="Inprogress">Inprogress</Option>
              <Option value="Complete">Complete</Option>
            </Select>
          </Form.Item>
        ),
        status: (
          <Form.Item
            name={['status']}
            rules={[
              {
                required: true,
                message: 'Input status!'
              }
            ]}
          >
            <Select
              className="quantitySelect"
              disabled={canUpdate}
              onChange={onChangeStatus}
            >
              <Option value="Inprogress">Inprogress</Option>
              <Option value="Complete">Complete</Option>
            </Select>
          </Form.Item>
        )
      }
    ];
  };

  const dataSourceNoInspection = (): DataType[] => {
    return [
      {
        key: '1',
        updateDate: (
          <Form.Item>
            {detailData?.status === 'Request' && (
              <Form.Item name={['updateDateSubmit']}>
                <DatePicker
                  style={{ width: '100%' }}
                  placeholder="YYYY.MM.DD 00:00:00"
                  className="inputRadious"
                  disabled={canUpdate}
                />
              </Form.Item>
            )}
            {detailData?.status === 'Inprogress' && (
              <Form.Item name={'updateDateSubmit'}>
                <DatePicker
                  className="inputRadious"
                  disabled={canUpdate}
                  style={{ width: '100%' }}
                  placeholder="YYYY.MM.DD 00:00:00"
                />
              </Form.Item>
            )}
            {detailData?.status === 'Complete' && (
              <Form.Item name={'updateDate'}>
                <DatePicker
                  style={{ width: '100%' }}
                  className="inputRadious"
                  disabled={canUpdate}
                  format={'YYYY.MM.DD hh:mm:ss A'}
                  placeholder="YYYY.MM.DD 00:00:00"
                />
              </Form.Item>
            )}
          </Form.Item>
        ),
        courier: (
          <Form.Item
            name={['courier']}
            rules={[
              {
                pattern: new RegExp(/^[a-zA-Z\s]*$/),
                message: 'Only English can be entered'
              }
            ]}
          >
            <Input className="inputRadious" disabled={canUpdate} />
          </Form.Item>
        ),
        trackingNumber: (
          <Form.Item
            name={['trackingNumber']}
            rules={[
              {
                pattern: new RegExp(/^[a-zA-Z0-9\s]*$/),
                message: 'Only English can be entered'
              }
            ]}
          >
            <Input className="inputRadious" disabled={canUpdate} />
          </Form.Item>
        ),
        deliveryStatus: (
          <Form.Item
            name={['deliveryStatus']}
            rules={[
              {
                required: true,
                message: 'Input status!'
              }
            ]}
          >
            <Select
              className="quantitySelect"
              disabled={canUpdate}
              onChange={onChangeStatus}
            >
              <Option value="Inprogress">Inprogress</Option>
              <Option value="Complete">Complete</Option>
            </Select>
          </Form.Item>
        )
      }
    ];
  };

  return (
    <>
      <Form
        form={form}
        ref={inputRef}
        onFinish={saveHandle}
        style={{ margin: 'auto' }}
        initialValues={{
          trackingNumber: defaultValue.trackingNumber,
          status: defaultValue.status,
          updateDate: defaultValue.updateDate ? defaultValue.updateDate : '',
          courier: defaultValue.courier
        }}
      >
        <Table
          className="warehouse-table"
          columns={showInspectionStatus ? columns : columnsNoInspection}
          dataSource={showInspectionStatus ? dataSource() : dataSourceNoInspection()}
          pagination={false}
          style={{ marginBottom: '40px' }}
        />
        {(canUpdate || isChange) ? <></> : (
          <Button
            type="primary"
            style={
              status
                ? {
                    color: 'black',
                    width: '95px',
                    marginLeft: 'auto',
                    display: 'block',
                    background: '#d9d9d9',
                    border: 'none'
                  }
                : {
                    width: '95px',
                    marginLeft: 'auto',
                    display: 'block',
                    background: '#2b2c51'
                  }
            }
            className="approve-button"
            htmlType="submit"
            disabled={status}
          >
            Save
          </Button>
        )}
      </Form>
      <Popup
        styleBackground="white"
        styleColor="#2A2D51"
        visible={popupOpen}
        textOk="Close"
        hiddenCancelBtn={true}
        title={popupContent}
        action_oke={() => setPopupOpen(false)}
      />
    </>
  );
})

export default ProgressForm;
